// @ts-nocheck
/**
 * Small circular avatar — first letter of name (or username) on a gradient
 * background that tracks the user's role tone from UserRoleBadge. Used in
 * the users-list "User" column and elsewhere we render a compact user
 * chip. No image loading needed — pure CSS gradient + a bold initial.
 */
import { cn } from '@/lib/utils/cn';
import { roleTone } from './UserRoleBadge';

interface Props {
  name?: string | null;
  username?: string | null;
  role?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const BG_GRADIENT: Record<string, string> = {
  violet:
    'bg-gradient-to-br from-violet-400 to-violet-600 text-white',
  sky:
    'bg-gradient-to-br from-sky-400 to-sky-600 text-white',
  emerald:
    'bg-gradient-to-br from-emerald-400 to-emerald-600 text-white',
  amber:
    'bg-gradient-to-br from-amber-400 to-amber-600 text-white',
  indigo:
    'bg-gradient-to-br from-indigo-400 to-indigo-600 text-white',
  slate:
    'bg-gradient-to-br from-slate-400 to-slate-600 text-white',
};

const SIZE_CLASSES = {
  sm: 'h-7 w-7 text-[11px]',
  md: 'h-9 w-9 text-sm',
  lg: 'h-12 w-12 text-base',
};

export function UserAvatar({ name, username, role, size = 'md', className }: Props) {
  const source = (name || username || '?').trim();
  const initial = source ? source.charAt(0).toUpperCase() : '?';
  const tone = roleTone(role);
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold shadow-sm',
        BG_GRADIENT[tone],
        SIZE_CLASSES[size],
        className,
      )}
      aria-hidden
    >
      {initial}
    </span>
  );
}
